import { config } from '@config';
import { defineModel } from 'foca';

export interface TurbosCurrentRpcNode {
  rpc: string;
  rpcKey: keyof typeof config.rpc | 'custom';
}

export interface TurbosBuyData {
  visible: boolean;
  token_address: string;
  name: string;
  symbol: string;
  iconUrl: string;
}

export const globalSettingModel = defineModel('global-setting', {
  initialState: <
    {
      slippage: string;
      isCustomSlippage: boolean;
      version: number | undefined;
      explorerKey: keyof typeof config.explorer_url;
      rpcKey: TurbosCurrentRpcNode['rpcKey'];
      buyData: TurbosBuyData;
    }
  >{
    slippage: 'Auto',
    isCustomSlippage: false,
    explorerKey: 'suivision',
    version: undefined,
    rpcKey: 'shinami',
    buyData: {
      visible: false,
      token_address: '',
      name: '',
      symbol: '',
      iconUrl: '',
    },
  },
  reducers: {
    setCustomSlippage(state, slippage: string) {
      state.slippage = slippage;
      state.isCustomSlippage = true;
    },
    setEnumSlippage(state, slippage: string) {
      state.slippage = slippage;
      state.isCustomSlippage = false;
    },
    setExplorerKey(state, key: keyof typeof config.explorer_url) {
      state.explorerKey = key;
    },
    setRpcKey(state, key: TurbosCurrentRpcNode['rpcKey']) {
      state.rpcKey = key;
    },
    setTradeVisible(state, data: TurbosBuyData) {
      state.buyData = data;
    },
    updateVersion(state, version: number) {
      state.version = version;
    },
  },
  methods: {
    explorerUrlForAccount(address: string) {
      const url =
        config.explorer_url[this.state.explorerKey]?.account || config.explorer_url.suiscan.account;
      return url.replace('{{account}}', address);
    },
    explorerUrlForObject(object: string) {
      const url =
        config.explorer_url[this.state.explorerKey]?.object || config.explorer_url.suiscan.object;
      return url.replace('{{object}}', object);
    },
    explorerUrlForCoin(coin: string) {
      const url =
        config.explorer_url[this.state.explorerKey]?.coin || config.explorer_url.suiscan.coin;
      return url.replace('{{coin}}', coin);
    },
    explorerUrlForTransaction(address: string) {
      const url =
        config.explorer_url[this.state.explorerKey]?.txb || config.explorer_url.suiscan.txb;
      return url.replace('{{txb}}', address);
    },
    init() {
      this.setState({
        ...this.state,
        buyData: {
          ...this.state.buyData,
          visible: false,
        },
      });
    },
  },
  events: {
    onInit() {
      this.init();
    },
  },
  computed: {
    realSlippage() {
      return this.state.slippage === 'Auto' ? '0.1' : this.state.slippage || '0.1';
    },
  },
});
